import { render, staticRenderFns } from "./DeptUserInfo.vue?vue&type=template&id=533e2547&scoped=true"
import script from "./DeptUserInfo.vue?vue&type=script&lang=js"
export * from "./DeptUserInfo.vue?vue&type=script&lang=js"
import style0 from "./DeptUserInfo.vue?vue&type=style&index=0&id=533e2547&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e2547",
  null
  
)

export default component.exports